import React, { useState } from 'react';
import styles from './TermosModal.module.css';

export default function TermosModal({ isOpen, onClose, onAccept }) {
  const [scrollBottom, setScrollBottom] = useState(false);

  if (!isOpen) return null;

  function handleScroll(e) {
    const el = e.target;
    const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
    if (isBottom) setScrollBottom(true);
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Termos de Uso e Privacidade</h2>
          <button className={styles.closeBtn} onClick={onClose} type="button">×</button>
        </div>

        <div className={styles.modalBody} onScroll={handleScroll}>
          <div className={styles.content}>
            <h3>1. Objeto do Serviço</h3>
            <p>
              O <strong>Analise Central</strong> é uma plataforma de consulta de dados públicos e cadastrais 
              (CPF, CNPJ, telefone, e-mail e nome) destinada exclusivamente a revendedores e 
              empresas para fins de análise de risco de crédito e prevenção à fraude.
            </p>

            <h3>2. Uso Adequado das Informações</h3>
            <p>
              O usuário se compromete a utilizar as informações obtidas através da plataforma 
              <strong>exclusivamente para fins comerciais legítimos</strong>, tais como:
            </p>
            <ul>
              <li>Análise de risco em operações de venda a prazo ou parcelada;</li>
              <li>Verificação de identidade de potenciais compradores;</li>
              <li>Prevenção e combate à fraude e inadimplência.</li>
            </ul>
            <p>
              É <strong>expressamente proibido</strong>:
            </p>
            <ul>
              <li>Utilizar os dados para fins de discriminação, perseguição ou assédio;</li>
              <li>Repassar, vender ou compartilhar dados de terceiros obtidos na plataforma;</li>
              <li>Realizar consultas sem o consentimento do titular dos dados, exceto quando 
                  amparado por interesse legítimo na prevenção de fraudes;</li>
              <li>Usar a plataforma para fins de espionagem, investigação particular ou 
                  qualquer atividade ilícita.</li>
            </ul>

            <h3>3. Base Legal e LGPD</h3>
            <p>
              As consultas realizadas no Analise Central baseiam-se no <strong>art. 7º, inciso IX 
              da Lei nº 13.709/2018 (LGPD)</strong>, que autoriza o tratamento de dados pessoais 
              para proteção do crédito, conforme regulamentação específica.
            </p>
            <p>
              O usuário declara estar ciente de que:
            </p>
            <ul>
              <li>Os dados consultados são obtidos de fontes públicas e bases cadastrais legalmente 
                  constituídas;</li>
              <li>O tratamento dos dados é realizado com base no interesse legítimo do controlador 
                  (prevenção de fraudes) e na proteção do crédito;</li>
              <li>O titular dos dados possui direitos previstos na LGPD, incluindo acesso, 
                  correção e exclusão.</li>
            </ul>

            <h3>3.1 Responsabilidade do Usuário</h3>
            <p>
              O usuário é o único responsável pelo uso que fizer das informações consultadas. 
              O Analise Central não se responsabiliza por:
            </p>
            <ul>
              <li>Decisões comerciais tomadas com base nos dados fornecidos;</li>
              <li>Uso indevido ou ilegal das informações pelo usuário;</li>
              <li>Danos decorrentes de informações desatualizadas ou incompletas fornecidas 
                  por fontes externas.</li>
            </ul>

            <h3>4. Créditos e Pagamento</h3>
            <p>
              O sistema funciona mediante a compra de <strong>créditos</strong> via Pix. Cada consulta 
              consome uma quantidade pré-definida de créditos. Os créditos não possuem prazo de 
              validade, mas não são reembolsáveis, exceto em casos de falha técnica comprovada 
              da plataforma.
            </p>

            <h3>5. Cadastro e Verificação</h3>
            <p>
              Para utilizar o serviço, o usuário deve:
            </p>
            <ul>
              <li>Ser pessoa jurídica devidamente registrada (CNPJ ativo);</li>
              <li>Fornecer dados verdadeiros e atualizados no cadastro;</li>
              <li>Verificar a propriedade do número de WhatsApp informado;</li>
              <li>Manter a senha de acesso em sigilo.</li>
            </ul>

            <h3>6. Suspensão e Cancelamento</h3>
            <p>
              O Analise Central reserva-se o direito de suspender ou cancelar o acesso de qualquer 
              usuário que:
            </p>
            <ul>
              <li>Viole os termos deste contrato;</li>
              <li>Utilize a plataforma para fins ilícitos ou não autorizados;</li>
              <li>Realize consultas em volume que caracterize uso abusivo ou automatizado 
                  (bots, scripts);</li>
              <li>Forneça dados falsos no cadastro.</li>
            </ul>

            <h3>7. Privacidade e Segurança</h3>
            <p>
              Adotamos medidas técnicas e organizacionais adequadas para proteger os dados 
              pessoais contra acessos não autorizados, destruição, perda ou alteração. 
              Os dados de acesso (logs de consulta) são mantidos pelo prazo legal de 
              <strong>5 (cinco) anos</strong> para fins de auditoria e cumprimento de obrigações 
              legais.
            </p>

            <h3>8. Alterações nos Termos</h3>
            <p>
              O Analise Central poderá alterar estes termos a qualquer momento. As alterações 
              serão comunicadas via e-mail ou notificação na plataforma. O uso continuado do 
              serviço após as alterações constitui aceitação dos novos termos.
            </p>

            <h3>9. Disposições Gerais</h3>
            <p>
              Estes termos são regidos pelas leis da República Federativa do Brasil. Qualquer 
              controvérsia será dirimida pelo foro da comarca de Goiânia/GO, com renúncia a 
              qualquer outro, por mais privilegiado que seja.
            </p>

            <p className={styles.lastUpdate}>
              <strong>Última atualização:</strong> 23 de junho de 2026
            </p>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            className={styles.btnCancel}
            onClick={onClose}
            type="button"
          >
            Fechar
          </button>
          <button
            className={`${styles.btnAccept} ${!scrollBottom ? styles.disabled : ''}`}
            onClick={onAccept}
            disabled={!scrollBottom}
            type="button"
          >
            {scrollBottom ? 'Li e aceito os termos' : 'Leia até o final para aceitar'}
          </button>
        </div>
      </div>
    </div>
  );
}
